import React, { useState, useEffect, useCallback } from "react";
import "../Styles/style.css";
import axios from "axios";
import { baseUrl } from "../../api/ipconfig";
import Pagination from "@mui/material/Pagination";
import { useLocation } from "react-router-dom";
import AdsResult from "../searchResult/adsResult";
import Lottie from "lottie-react";
import NotAvailable from "../../images/not-found.json";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import LoadingModal from "../modals/loading-modal";
export default function RecommenderResult() {
  const location = useLocation();
  const [postData, setPostData] = useState([]);

  // Extract query parameters from location.search
  const queryParams = new URLSearchParams(location.search);
  const selectedMake = queryParams.get("mk");
  const selectedModel = queryParams.get("md");
  const selectedYear = queryParams.get("year");
  const selectedCity = queryParams.get("ct");
  const selectedCategories = queryParams.get("ctg");
  const selectedCondition = queryParams.get("cnd");
  const selectedMinPrice = queryParams.get("min");
  const selectedMaxPrice = queryParams.get("mxp");

  const [page, setPage] = React.useState(1);

  const [loading, setLoading] = React.useState(false);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const fetchData = useCallback(async (page) => {
    try {
      setLoading(true);

      const response = await axios.get(`${baseUrl}/filterpost`, {
        params: {
          search_name: "",
          condition: selectedCondition || "new",
          city_name: [selectedCity],
          makeName: [selectedMake],
          modelName: [selectedModel],
          year_id: [selectedYear],
          price_from: selectedMinPrice,
          price_to: selectedMaxPrice,
          enginecapacity: selectedCategories,
          mileage: 0,
          transmition: "",
          enginetype: "",
          addtype: "",
          page: page,
        },
      });

      setPostData(response?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    fetchData(page);
  }, [fetchData, page]);

  return (
    <>
      <LoadingModal open={loading} onClose={() => setLoading(false)} />

      <div className="container">
        <div className="row mb-5 mt-2">
          <div className="col-lg-2 col-md-2"></div>
          <div className="col-lg-8 col-md-10">
            <h3 className="fw-700">
              <span style={{ color: "#b80505", fontWeight: 800, fontSize: 28 }}>
                {postData?.length}
              </span>{" "}
              Best Matched Cars for You
            </h3>
            {postData?.length === 0 ? (
              <div className="notBidsAvail text-center">
                <Lottie
                  style={{ height: 200 }}
                  animationData={NotAvailable}
                  loop
                />
                <h5 className="fw-600">No cars available</h5>
                <Link to="/car-suggest">
                  <Button
                    variant="contained"
                    className="bgSecondary mt-3 color-white fw-700 text-capitalize rounded-pill  py-2 px-4"
                  >
                    Search Another
                  </Button>
                </Link>
              </div>
            ) : postData?.length > 0 ? (
              <AdsResult postData={postData} />
            ) : null}

          </div>
          <div className="col-lg-2 col-md-2"></div>
        </div>
      </div>
    </>
  );
}
